import React from 'react';
import { Button, Typography, TypographyType, TypographyVariant } from 'src/components-dummy';
import { AddItemCardProps } from './types';
import './AddItemCard.scss';

export const AddItemCard = ({
  title,
  children,
  summary,
  onApply,
  onCancel,
  isApplyDisabled,
}: AddItemCardProps): JSX.Element => (
  <div className='syte-add-item-card'>
    <Typography
      type={TypographyType.Body}
      variant={TypographyVariant.MediumBold}
      className='syte-add-item-card-title'
    >
      {title}
    </Typography>
    <div className='syte-add-item-card-body'>{children}</div>
    {summary && (
      <Typography
        type={TypographyType.Body}
        variant={TypographyVariant.SmallRegular}
        className='syte-add-item-card-summary'
      >
        {summary}
      </Typography>
    )}
    <div className='syte-add-item-card-footer'>
      <Button variant='tertiary' onClick={onCancel}>
        Cancel
      </Button>
      <Button variant='primary' onClick={onApply} disabled={isApplyDisabled}>
        Apply
      </Button>
    </div>
  </div>
);
